module.exports = __webpack_public_path__ + "img/TPM_yourpath.23e51d1f.svg";